import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import authApi from "../../data/api/authApi";
import { useLanguage } from "../helpers/LanguageContext";
import "../../css/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await authApi.forgotPasswordApi(email);
      setIsError(false);
      setMessage(t("forgotPasswordSuccess"));
    } catch (error) {
      setIsError(true);
      setMessage(t("forgotPasswordError"));
      console.error("Forgot password error:", error);
    }
  };

  return (
    <Container fluid className="forgot-password-page">
      <div className="forgot-password-card shadow-sm">
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <h3 className="forgot-password-title">{t("forgotPasswordTitle")}</h3>

          {message && (
            <div
              className={`alert ${
                isError ? "alert-danger" : "alert-info"
              } forgot-password-alert`}
            >
              {message}
            </div>
          )}

          <div className="forgot-password-field">
            <label className="form-label">{t("email")}</label>
            <input
              type="email"
              className="form-control forgot-password-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="d-grid gap-2 forgot-password-actions">
            <Button type="submit" className="forgot-password-submit-btn">
              {t("forgotPasswordSubmit")}
            </Button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default ForgotPassword;
